import React from 'react';
import { Plus, X } from 'lucide-react';

import { cn } from '@ui/lib/utils';

/** A picked pill is grey with a cross; one that can be picked is dashed with a plus. */
export const pillClass = (pressed: boolean): string =>
  cn(
    'inline-flex shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap rounded-full border py-1 pr-2 pl-3 text-sm transition-colors outline-none focus-visible:ring-3 focus-visible:ring-ring/50',
    pressed
      ? 'border-transparent bg-muted text-foreground hover:bg-muted/70'
      : 'border-dashed border-border bg-transparent text-muted-foreground hover:border-foreground/40 hover:text-foreground',
  );

export const PillContent = ({
  children,
  pressed,
  isDisabled,
}: {
  children: React.ReactNode;
  pressed: boolean;
  isDisabled?: boolean;
}): JSX.Element => {
  const Icon = pressed ? X : Plus;

  return (
    <>
      {children}
      {!isDisabled && <Icon className="size-3.5" aria-hidden />}
    </>
  );
};
